<template>
  <div class="confirmOpen">
    <c-nav></c-nav>
    <div class="head">
      <div class="light"></div>
      <div class="header">
        <div class="cost"></div>
        <div class="goldBox">
          高铁管家
          <span>黄金会员</span>礼包
        </div>
        <div class="differentTrip"></div>
      </div>
    </div>
    <div class="body">
      <div class="title">购超值出行礼包，送黄金会员专属权益</div>
      <div :class="['passengerGift',type===1?'unselected':'']" @click="selectGift(0)">
        <div class="left">
          <div class="passengerGiftTitle">优先加速的抢票礼包</div>
          <div class="desc">光速抢票券5张</div>
          <div class="desc">优先出票券5张</div>
          <div class="subDesc">总价值：40x5+20x5=300元，现购立省251元</div>
        </div>
        <div class="right fx fx-center">
          <div :class="[type===1?'unselect':'selected']"></div>
        </div>
      </div>
      <div :class="['speedGift',type===0?'unselected':'']" @click="selectGift(1)">
        <div class="left">
          <div class="speedGiftTitle"></div>
          <div class="speedGiftTitle">单单返现的常旅客礼包</div>
          <div class="desc">火车票首单立返15元</div>
          <div class="desc">1年内每单返现5元</div>
          <div class="subDesc">限本人购票，全年最高返现：15+5x8=55元</div>
        </div>
        <div class="right fx fx-center">
          <div :class="[type===1?'selected':'unselect']"></div>
        </div>
      </div>
      <div class="pay" @click="gotoPay">支付49元开通黄金会员</div>

      <div class="insturecion fx-row fx-c-center">
        <div
          :class="[isSelected?'selectedInstruction':'unSelectedInstruction']"
          @click="selectInstruction"
        ></div>
        <div class="goldInstruction">
          <span class="agree">已阅读并同意</span>
          <span @click="gotoInstruction">高铁管家黄金礼包说明</span>
        </div>
      </div>
    </div>
    <div class="xBottom" v-if="iphoneX"></div>
    <success
      :showSuccess="isShowSuccess"
      :text="successText"
      @checkPriority="checkPriority"
      @closeSuccess="closeSuccess"
    ></success>
    <share :isShow="isShowShare" @show="showShare" @close="closeShare"></share>
  </div>
</template>
<script>
import success from "./components/success";
import share from "./components/share";

import { mapState, mapMutations, mapActions } from "vuex";
import auth from "@/request/auth.js";
import { handleException } from "@/request/helpers.js";
import { get } from "@/request/utils";

import localStorage from "@/utils/localStorage.js";
import nativeAPI from "@/utils/nativeApi";
import { h5PayV2 } from '@/utils/payHandler'
import setNavigationBarColor from "./mixin/setNavigationBarColor.js";
import downloadApp from '../../Helper/download-app.js';

const queryString = require("query-string");

export default {
  data() {
    return {
      isShowSuccess: 0,
      showInstruction: true,
      successText: null,
      isShowShare: false,
      navigationBarColor: "255,255,255,1",
      iphoneX: false,
      isReplaceWxPayPage: false // 跳转去h5支付页面是否需要replace当前页面
    };
  },
  mixins: [setNavigationBarColor],
  components: {
    success,
    share
  },
  methods: {
    ...mapMutations("vipCard/goldSale", [
      "changeInstruction",
      "changeGiftType"
    ]),
    ...mapActions("vipCard/goldSale", ["creatGlodVIPMonye"]),
    isIphoneX() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height == 812 && screen.width == 375)
      );
    },
    showShare() {
      this.isShowShare = true;
    },
    closeShare() {
      this.isShowShare = false;
    },
    selectInstruction() {
      this.changeInstruction();
    },
    gotoInstruction() {
      this.$router.push({
        path: "/vipCard/goldInstruction"
      });
    },
    selectGift(type) {
      this.changeGiftType(type);
    },
    gotoPay() {
      // console.log('开始支付');
      if (!this.isSelected) {
        return this.$notify({
          message: "请阅读并同意高铁管家黄金礼包说明",
          showClose: true
        });
      } else {
        //下单
        auth
          .ensure({
            method: "replace",
            callback: this.createOrder
          })
          .then(() => {
            // console.log('开始创建订单');
            this.createOrder();
          })
          .catch(err => {
            handleException.call(this, err, true, this.createOrder);
          });
      }
    },
    createOrder() {
      let ptid = localStorage.get("ptid") || "";
      let origin = "hw-" + ptid;
      this.creatGlodVIPMonye({
        id: "priv_008",
        buyType: this.type,
        origin
      })
        .then(res => {
          if (!this.isNative) {
            this.h5Pay(res);
          } else if (this.isNative) {
            // console.log('native');
            this.nativePay(res);
          }
        })
        .catch(err => {
          // console.log(err, 'err++++++');
          handleException.call(this, err, true);
        });
    },
    h5Pay(res) {
      const payOrderId = get(res, 'res.bd.data.payid', '');
      const oid = get(res, 'res.bd.data.orderid', '');
      const ptid = localStorage.get('ptid') || '';
      const currentUrl = location.href.split('?')[0];
      const successPage = `${currentUrl}?oid=${oid}&success=1&type=${ this.type }&ptid=${ptid}`
      const params = {
        payOrderId,
        expireMinute: 30,
        orderBrief: {
          name: 'gaotie_act',
          data: {
            title: '高铁管家黄金会员',
            desc: '有效期365天',
            img: 'https://cdn.133.cn/gtgj/web/goldSale/goldpay.png'
          }
        },
        disableStatePage: true,
        successPage,
      };

      h5PayV2(params);
    },
    nativePay(res) {
      let payUrl = get(res, "res.bd.data.payurl");
      let params = queryString.parse(payUrl);

      nativeAPI
        .invoke("startPay", params)
        .then(res => {
          if (res && res.SUCC == res.value) {
            this.$router.replace({
              path: `/vipCard/goldSaleOpen?success=1&type=${this.type}`
            });
          }
        })
        .catch(err => {
          handleException.call(this, err, true);
        });
    },
    closeSuccess() {
      this.isShowSuccess = 0;
    },
    checkPriority() {
      if (this.isNative) {
        location.href =
          "gtgj://start?type=weex&project_name=gtgj&hlo_module=gtgj&product_module=Membership&hlo_path=home&hlo_context_params=eyJsZXZlbCI6IjMifQ%3D%3D";
      } else if (!this.isNative) {
        downloadApp();
      }
    },
    init() {
      this.isShowSuccess = parseInt(this.$route.query.success);
      let type = parseInt(this.$route.query.type);

      if (type === 1) {
        this.successText = {
          desc: "1年单单返现的常旅客礼包",
          subDesc: "购票还可立赚返现"
        };
      } else if (type === 0) {
        this.successText = {
          desc: "优先加速的抢票礼包",
          subDesc: "购票立享黄金会员专属权益"
        };
      }
    }
  },
  computed: {
    ...mapState("vipCard/goldSale", [
      "type", //礼包种类  1:常旅客礼包  0:加速包
      "isSelected", //是否选中同意协议
      "isNative" //是否是客户端
    ])
  },
  mounted() {
    this.$updateTitle("黄金会员礼包");
  },
  created() {
    this.init();
    this.iphoneX = this.isIphoneX();

    let isReplaceWxPayPage = localStorage.get("isReplaceWxPayPage");
    if (isReplaceWxPayPage) {
      this.isReplaceWxPayPage = true;
      localStorage.remove("isReplaceWxPayPage");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
@import "./style/common.scss";
.confirmOpen {
  font-size: 20 * $px;
  min-height: 100%;
  background-color: #000;
  .head {
    height: 179 * $px;
    overflow: hidden;
    position: relative;
    .light {
      width: 208 * $px;
      height: 148 * $px;
      position: absolute;
      z-index: 0;
      right: 0;
      top: 0;
      @include bg("light@3x.png");
    }
    .header {
      width: 375 * $px;
      padding: 27 * $px 0 24 * $px 0;
      position: absolute;
      top: 0;
      left: 0;
      .cost {
        margin: 0 auto;
        width: 221 * $px;
        height: 29 * $px;
        @include bg("cost@3x.png");
        margin-bottom: 10 * $px;
      }
      .goldBox {
        margin: 0 auto;
        margin-bottom: 10 * $px;
        width: 217 * $px;
        height: 28 * $px;
        line-height: 28 * $px;
        background-image: linear-gradient(-180deg, #d7a15d 0%, #cc9d64 100%);
        box-shadow: inset 0 1px 1px 0 rgba(255, 253, 251, 0.47);
        border-radius: 14px;
        font-size: 16 * $px;
        color: #593600;
        letter-spacing: 1px;
        text-align: center;
        font-family: PingFangSC-Medium;
        span {
          color: #ffebc2;
        }
      }
      .differentTrip {
        margin: 0 auto;
        width: 284 * $px;
        height: 51 * $px;
        @include bg("differentTrip@3x.png");
      }
    }
  }
  .body {
    // margin-top: 172*$px;
    width: 375 * $px;
    height: 431 * $px;
    overflow: hidden;
    @include bg("confirmOpenBody@3x.png");
    .title {
      margin-top: 16 * $px;
      margin-left: 29 * $px;
      margin-bottom: 16 * $px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #593600;
      letter-spacing: 0;
    }
    .passengerGift,
    .speedGift {
      margin-left: 29 * $px;
      margin-bottom: 10 * $px;
      @include bg("selectedPassenger@3x.png");
      width: 317 * $px;
      height: 107 * $px;
      position: relative;
      .left {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 12 * $px;
        .passengerGiftTitle,
        .speedGiftTitle {
          margin-top: 16 * $px;
          font-family: PingFangSC-Medium;
          font-size: 14 * $px;
          color: #593600;
          letter-spacing: 0;
          line-height: 13 * $px;
          margin-bottom: 10 * $px;
        }
        .desc {
          font-family: PingFangSC-Regular;
          font-size: 12 * $px;
          color: #ba792f;
          letter-spacing: 0;
          line-height: 12 * $px;
          margin-bottom: 8 * $px;
          position: relative;
          // padding-left: 12*$px;
          padding-left: 12 * $px;
          &::before {
            position: absolute;
            top: 3 * $px;
            left: 1 * $px;
            display: block;
            content: "";
            height: 5 * $px;
            width: 5 * $px;
            transform: rotate(-45deg);
            background: #ba792f;
            border-radius: 1 * $px;
          }
        }
        .subDesc {
          font-family: PingFangSC-Regular;
          font-size: 10 * $px;
          color: #dab589;
          letter-spacing: 0;
        }
      }
      .right {
        position: absolute;
        top: 25 * $px;
        right: 14 * $px;
        width: 54 * $px;
        height: 54 * $px;
        background: #f7e1b2;
        border-radius: 50%;
        box-sizing: border-box;
        .buyNow {
          font-family: PingFangSC-Medium;
          font-size: 13 * $px;
          color: #ba792f;
          letter-spacing: 0;
          text-align: center;
          line-height: 15 * $px;
        }
        .selected {
          width: 27 * $px;
          height: 27 * $px;
          @include bg("gouSelected@3x.png");
        }
        .unselect {
          width: 27 * $px;
          height: 27 * $px;
          @include bg("gouUnselect@3x.png");
        }
      }
    }
    .unselected {
      opacity: 0.5;
    }
    .speedGift {
      @include bg("selectedSpeed@3x.png");
    }
    .insturecion {
      margin-top: 12 * $px;
      .unSelectedInstruction,
      .selectedInstruction {
        margin-left: 73 * $px;
        margin-right: 8 * $px;
        width: 15 * $px;
        height: 15 * $px;
        @include bg("boxUnselected@3x.png");
        border-radius: 4 * $px;
        background-color: #fff;
      }
      .selectedInstruction {
        @include bg("boxSelected@3x.png");
        background-size: cover;
      }
      .goldInstruction {
        // opacity: 0.6;
        font-family: PingFangSC-Medium;
        font-size: 13 * $px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        .agree {
          opacity: 0.6;
        }
      }
    }
    .pay {
      width: 290 * $px;
      height: 44 * $px;
      line-height: 44 * $px;
      margin: 0 auto;
      margin-top: 53 * $px;
      background: #4e2b04;
      border-radius: 4px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #ffebc2;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .xBottom {
    background: #996032;
    margin-top: -1 * $px;
    height: 70 * $px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldSale/confirmOpen.vue